module.exports = __webpack_public_path__ + "img/ry_8.320db788.png";